import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/templates")({
  beforeLoad: () => {
    throw redirect({ to: "/settings", search: {"tab":"templates"}, replace: true });
  },
});
